import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Auth0LoginButton, buildAuth0PopupUrl, useAuth } from 'grabbitbot-legacy-ui'
import { loginErrorFrom } from '../../lib/loginError'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, BRAND, POST_LOGIN_PATH } from '../../config'

// Login is the Auth0 BFF popup + postMessage handoff, exactly as the sibling
// UIs do it (simple.cryptopairscreener.com, secure.grabbitbot.com): the popup
// opens the backend's `GET /user/login/auth0`, the backend performs the OIDC
// code exchange (state + nonce bound) and posts its own session token back;
// `Auth0LoginButton` checks the message origin. Nothing here accepts a token
// from anywhere else. The legacy e-mail/password + Google-popup flows are
// gone (port plan K1 = A).
export function LoginPage() {
  const navigate = useNavigate()
  const { status } = useAuth()
  const [loginError, setLoginError] = useState<string | null>(null)

  useEffect(() => {
    function onMessage(event: MessageEvent) {
      const text = loginErrorFrom(event, AUTH0_LOGIN_EXPECTED_ORIGIN)
      if (text) setLoginError(text)
    }
    window.addEventListener('message', onMessage)
    return () => window.removeEventListener('message', onMessage)
  }, [])

  useEffect(() => {
    if (status === 'authenticated') navigate(POST_LOGIN_PATH, { replace: true })
  }, [status, navigate])

  const goToApp = () => navigate(POST_LOGIN_PATH, { replace: true })

  return (
    <div className="wnf-card wnf-card--auth">
      <h1>Sign in to {BRAND}</h1>
      <p className="wnf-muted">A simulated spot exchange — everything on it is test funds, no real money.</p>
      {loginError && (
        <p role="alert" className="wnf-alert" data-testid="login-error">
          {loginError}
        </p>
      )}
      <p>
        <Auth0LoginButton popupUrl={AUTH0_LOGIN_URL} expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN} onSuccess={goToApp}>
          Log in
        </Auth0LoginButton>
      </p>
      <p>
        <Auth0LoginButton
          popupUrl={buildAuth0PopupUrl(AUTH0_LOGIN_URL, { connection: 'google-oauth2' })}
          expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
          onSuccess={goToApp}
        >
          Continue with Google
        </Auth0LoginButton>
      </p>
      <p>
        No account yet? <Link to="/register">Register</Link>
      </p>
    </div>
  )
}
